import { format } from 'date-fns'

import { FORMAT_YEAR_MONTH_DAY_HYPHEN } from '../constants'

const formatPolicyDate = (policyDate: Date): string => {
  return String(format(policyDate, FORMAT_YEAR_MONTH_DAY_HYPHEN))
}

export default formatPolicyDate
